export const exchange = {
  AED: 3.673019,
  AFN: 79.030285,
  ALL: 102.827543,
  AMD: 508.430002,
  ANG: 1.795936,
  AOA: 647.19,
  ARS: 95.5253,
  AUD: 1.321209,
  AWG: 1.8,
  AZN: 1.700805,
  BAM: 1.638968,
  BBD: 2,
  BDT: 84.838098,
  BGN: 1.6399,
  BHD: 0.377047,
  BIF: 1980.416568,
  BMD: 1,
  BND: 1.343266,
  BOB: 6.912196,
  BRL: 4.9262,
  BSD: 1,
  BTC: 0.000028793414,
  BTN: 74.234653,
  BWP: 10.833969,
  BYN: 2.528638,
  BZD: 2.016761,
  CAD: 1.233873,
  CDF: 1986.98927,
  CHF: 0.919638,
  CLF: 0.026615,
  CLP: 734.999721,
  CNH: 6.460452,
  CNY: 6.4561,
  COP: 3748.805985,
  CRC: 620.020264,
  CUC: 1,
  CUP: 25.75,
  CVE: 95.85,
  CZK: 21.3137,
  DJF: 178.117125,
  DKK: 6.235261,
  DOP: 57.029132,
  DZD: 134.025945,
  EGP: 15.6705,
  ERN: 15.002,
  ETB: 43.852804,
  EUR: 0.838491,
  FJD: 2.06105,
  FKP: 0.720389,
  GBP: 0.720389,
  GEL: 3.145,
  GGP: 0.720389,
  GHS: 5.826084,
  GIP: 0.720389,
  GMD: 51.12,
  GNF: 9825.773055,
  GTQ: 7.753029,
  GYD: 209.277218,
  HKD: 7.76251,
  HNL: 23.909491,
  HRK: 6.285,
  HTG: 92.84378,
  HUF: 294.013389,
  IDR: 14484.5,
  ILS: 3.259376,
  IMP: 0.720389,
  INR: 74.288549,
  IQD: 1459.733973,
  IRR: 42105,
  ISK: 123.5,
  JEP: 0.720389,
  JMD: 150.081709,
  JOD: 0.709,
  JPY: 110.61383333,
  KES: 107.840346,
  KGS: 84.589799,
  KHR: 4083.030315,
  KMF: 412.900102,
  KPW: 900,
  KRW: 1130.199897,
  KWD: 0.301073,
  KYD: 0.833773,
  KZT: 426.934748,
  LAK: 9479.741907,
  LBP: 1512.7593,
  LKR: 199.100909,
  LRD: 171.450049,
  LSL: 14.087217,
  LYD: 4.50468,
  MAD: 8.895966,
  MDL: 17.994133,
  MGA: 3788.61044,
  MKD: 51.644236,
  MMK: 1646.836879,
  MNT: 2847.354137,
  MOP: 7.999581,
  MRO: 356.999828,
  MRU: 36.168144,
  MUR: 42.500566,
  MVR: 15.41,
  MWK: 806.003963,
  MXN: 19.819506,
  MYR: 4.146,
  MZN: 63.301999,
  NAD: 14.18,
  NGN: 410.5,
  NIO: 34.942385,
  NOK: 8.526793,
  NPR: 118.7756,
  NZD: 1.41997,
  OMR: 0.385012,
  PAB: 1,
  PEN: 3.980892,
  PGK: 3.559924,
  PHP: 48.643042,
  PKR: 157.880022,
  PLN: 3.774834,
  PYG: 6783.667427,
  QAR: 3.644131,
  RON: 4.1312,
  RSD: 98.551947,
  RUB: 72.2358,
  RWF: 1006.38561,
  SAR: 3.750014,
  SBD: 8.016064,
  SCR: 15.073168,
  SDG: 449.5,
  SEK: 8.51328,
  SGD: 1.34319,
  SHP: 0.720389,
  SLL: 10252.949863,
  SOS: 578.750851,
  SRD: 20.8535,
  SSP: 130.26,
  STD: 20518.098064,
  STN: 20.7,
  SVC: 8.75508,
  SYP: 1257.850565,
  SZL: 14.08571,
  THB: 31.912667,
  TJS: 11.410769,
  TMT: 3.51,
  TND: 2.7725,
  TOP: 2.241465,
  TRY: 8.6893,
  TTD: 6.791117,
  TWD: 27.854999,
  TZS: 2320.58393,
  UAH: 27.36477,
  UGX: 3556.825487,
  USD: 1,
  UYU: 43.456944,
  UZS: 10575.982571,
  VES: 3209358.225806,
  VND: 23046.330931,
  VUV: 109.647402,
  WST: 2.542132,
  XAF: 550.014171,
  XAG: 0.03830465,
  XAU: 0.0005623,
  XCD: 2.70255,
  XDR: 0.700151,
  XOF: 550.014171,
  XPD: 0.00037137,
  XPF: 100.058616,
  XPT: 0.00091283,
  YER: 250.200039,
  ZAR: 14.26567,
  ZMW: 22.618639,
  ZWL: 322,
};

const countries = {
  AED: "United Arab Emirates Dirham",
  AFN: "Afghan Afghani",
  ALL: "Albanian Lek",
  AMD: "Armenian Dram",
  ANG: "Netherlands Antillean Guilder",
  AOA: "Angolan Kwanza",
  ARS: "Argentine Peso",
  AUD: "Australian Dollar",
  AWG: "Aruban Florin",
  AZN: "Azerbaijani Manat",
  BAM: "Bosnia-Herzegovina Convertible Mark",
  BBD: "Barbadian Dollar",
  BDT: "Bangladeshi Taka",
  BGN: "Bulgarian Lev",
  BHD: "Bahraini Dinar",
  BIF: "Burundian Franc",
  BMD: "Bermudan Dollar",
  BND: "Brunei Dollar",
  BOB: "Bolivian Boliviano",
  BRL: "Brazilian Real",
  BSD: "Bahamian Dollar",
  BTC: "Bitcoin",
  BTN: "Bhutanese Ngultrum",
  BWP: "Botswanan Pula",
  BYN: "Belarusian Ruble",
  BZD: "Belize Dollar",
  CAD: "Canadian Dollar",
  CDF: "Congolese Franc",
  CHF: "Swiss Franc",
  CLF: "Chilean Unit of Account (UF)",
  CLP: "Chilean Peso",
  CNH: "Chinese Yuan (Offshore)",
  CNY: "Chinese Yuan",
  COP: "Colombian Peso",
  CRC: "Costa Rican Colón",
  CUC: "Cuban Convertible Peso",
  CUP: "Cuban Peso",
  CVE: "Cape Verdean Escudo",
  CZK: "Czech Republic Koruna",
  DJF: "Djiboutian Franc",
  DKK: "Danish Krone",
  DOP: "Dominican Peso",
  DZD: "Algerian Dinar",
  EGP: "Egyptian Pound",
  ERN: "Eritrean Nakfa",
  ETB: "Ethiopian Birr",
  EUR: "Euro",
  FJD: "Fijian Dollar",
  FKP: "Falkland Islands Pound",
  GBP: "British Pound Sterling",
  GEL: "Georgian Lari",
  GGP: "Guernsey Pound",
  GHS: "Ghanaian Cedi",
  GIP: "Gibraltar Pound",
  GMD: "Gambian Dalasi",
  GNF: "Guinean Franc",
  GTQ: "Guatemalan Quetzal",
  GYD: "Guyanaese Dollar",
  HKD: "Hong Kong Dollar",
  HNL: "Honduran Lempira",
  HRK: "Croatian Kuna",
  HTG: "Haitian Gourde",
  HUF: "Hungarian Forint",
  IDR: "Indonesian Rupiah",
  ILS: "Israeli New Sheqel",
  IMP: "Manx pound",
  INR: "Indian Rupee",
  IQD: "Iraqi Dinar",
  IRR: "Iranian Rial",
  ISK: "Icelandic Króna",
  JEP: "Jersey Pound",
  JMD: "Jamaican Dollar",
  JOD: "Jordanian Dinar",
  JPY: "Japanese Yen",
  KES: "Kenyan Shilling",
  KGS: "Kyrgystani Som",
  KHR: "Cambodian Riel",
  KMF: "Comorian Franc",
  KPW: "North Korean Won",
  KRW: "South Korean Won",
  KWD: "Kuwaiti Dinar",
  KYD: "Cayman Islands Dollar",
  KZT: "Kazakhstani Tenge",
  LAK: "Laotian Kip",
  LBP: "Lebanese Pound",
  LKR: "Sri Lankan Rupee",
  LRD: "Liberian Dollar",
  LSL: "Lesotho Loti",
  LYD: "Libyan Dinar",
  MAD: "Moroccan Dirham",
  MDL: "Moldovan Leu",
  MGA: "Malagasy Ariary",
  MKD: "Macedonian Denar",
  MMK: "Myanma Kyat",
  MNT: "Mongolian Tugrik",
  MOP: "Macanese Pataca",
  MRO: "Mauritanian Ouguiya (pre-2018)",
  MRU: "Mauritanian Ouguiya",
  MUR: "Mauritian Rupee",
  MVR: "Maldivian Rufiyaa",
  MWK: "Malawian Kwacha",
  MXN: "Mexican Peso",
  MYR: "Malaysian Ringgit",
  MZN: "Mozambican Metical",
  NAD: "Namibian Dollar",
  NGN: "Nigerian Naira",
  NIO: "Nicaraguan Córdoba",
  NOK: "Norwegian Krone",
  NPR: "Nepalese Rupee",
  NZD: "New Zealand Dollar",
  OMR: "Omani Rial",
  PAB: "Panamanian Balboa",
  PEN: "Peruvian Nuevo Sol",
  PGK: "Papua New Guinean Kina",
  PHP: "Philippine Peso",
  PKR: "Pakistani Rupee",
  PLN: "Polish Zloty",
  PYG: "Paraguayan Guarani",
  QAR: "Qatari Rial",
  RON: "Romanian Leu",
  RSD: "Serbian Dinar",
  RUB: "Russian Ruble",
  RWF: "Rwandan Franc",
  SAR: "Saudi Riyal",
  SBD: "Solomon Islands Dollar",
  SCR: "Seychellois Rupee",
  SDG: "Sudanese Pound",
  SEK: "Swedish Krona",
  SGD: "Singapore Dollar",
  SHP: "Saint Helena Pound",
  SLL: "Sierra Leonean Leone",
  SOS: "Somali Shilling",
  SRD: "Surinamese Dollar",
  SSP: "South Sudanese Pound",
  STD: "São Tomé and Príncipe Dobra (pre-2018)",
  STN: "São Tomé and Príncipe Dobra",
  SVC: "Salvadoran Colón",
  SYP: "Syrian Pound",
  SZL: "Swazi Lilangeni",
  THB: "Thai Baht",
  TJS: "Tajikistani Somoni",
  TMT: "Turkmenistani Manat",
  TND: "Tunisian Dinar",
  TOP: "Tongan Pa'anga",
  TRY: "Turkish Lira",
  TTD: "Trinidad and Tobago Dollar",
  TWD: "New Taiwan Dollar",
  TZS: "Tanzanian Shilling",
  UAH: "Ukrainian Hryvnia",
  UGX: "Ugandan Shilling",
  USD: "United States Dollar",
  UYU: "Uruguayan Peso",
  UZS: "Uzbekistan Som",
  VEF: "Venezuelan Bolívar Fuerte (Old)",
  VES: "Venezuelan Bolívar Soberano",
  VND: "Vietnamese Dong",
  VUV: "Vanuatu Vatu",
  WST: "Samoan Tala",
  XAF: "CFA Franc BEAC",
  XAG: "Silver Ounce",
  XAU: "Gold Ounce",
  XCD: "East Caribbean Dollar",
  XDR: "Special Drawing Rights",
  XOF: "CFA Franc BCEAO",
  XPD: "Palladium Ounce",
  XPF: "CFP Franc",
  XPT: "Platinum Ounce",
  YER: "Yemeni Rial",
  ZAR: "South African Rand",
  ZMW: "Zambian Kwacha",
  ZWL: "Zimbabwean Dollar",
};
